import { EMPTY_STRING } from '@e-socna/empty';

import { environment } from '../../../../../environment';

export const downloadFile = (uri: string): void => {
  const url = `${environment.backendUrl}/${uri}/download`;
  const link = document.createElement('a');
  // eslint-disable-next-line functional/immutable-data
  link.href = url;
  // eslint-disable-next-line functional/immutable-data
  link.download = EMPTY_STRING;
  link.click();
};
